"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.serverRender = serverRender;
exports.clientRender = clientRender;
exports.CatalogGroupPage = exports.GroupHeader = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactDom = babelHelpers.interopRequireDefault(require("react-dom"));

var _server = babelHelpers.interopRequireDefault(require("react-dom/server"));

var _exports = babelHelpers.interopRequireDefault(require("exports"));

var Pie = _interopRequireWildcard(require("pie"));

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var _catalogMobileNav = babelHelpers.interopRequireDefault(require("modals/catalog-mobile-nav"));

var _TopicModal = babelHelpers.interopRequireDefault(require("components/TopicModal"));

var _Cart = babelHelpers.interopRequireDefault(require("Cart"));

var _fetch = babelHelpers.interopRequireDefault(require("fetch"));

var _noty = require("noty");

var _decorators = require("decorators");

var _search = babelHelpers.interopRequireDefault(require("modals/search"));

var _class, _descriptor, _descriptor2, _class3, _descriptor3, _class5;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || babelHelpers.typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = babelHelpers.getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = babelHelpers.getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return babelHelpers.possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function serverRender(props) {
  var id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'catalogGroupPage';
  var minimumSortMenuCount = _exports.default.Channel.channelDetails.MinimumCountForCatalogSortMenu;
  var arg = Object.assign({
    minimumSortMenuCount: minimumSortMenuCount,
    className: 'stack catalog-group'
  }, props); // var arg = {groupTree, tileList, sortOrder, filter, defaultSortOrder, includeUserSpecifiedSort, defaultFilterType, itemStyle, base, query, minimumSortMenuCount}

  return "\n\t\t<div id='".concat(id, "' data-catalog='").concat(HTML.encode(JSON.stringify(arg)), "'>").concat(_server.default.renderToString( /*#__PURE__*/_react.default.createElement(CatalogGroupPage, arg)), "</div>\n\t\t<script>\n\t\t\tvar node = document.querySelector('#").concat(id, "');\n\t\t\trequire('CatalogGroupPage').clientRender(node, JSON.parse(node.dataset.catalog));\n\t\t</script>\n\t");
}

function clientRender(element, arg) {
  _reactDom.default.render( /*#__PURE__*/_react.default.createElement(CatalogGroupPage, arg), element);
}

var GroupTree = (_class = /*#__PURE__*/function (_Component) {
  babelHelpers.inherits(GroupTree, _Component);

  var _super = _createSuper(GroupTree);

  function GroupTree() {
    var _this;

    babelHelpers.classCallCheck(this, GroupTree);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    babelHelpers.initializerDefineProperty(_this, "tree", _descriptor, babelHelpers.assertThisInitialized(_this));
    babelHelpers.initializerDefineProperty(_this, "expanded", _descriptor2, babelHelpers.assertThisInitialized(_this));
    return _this;
  }

  babelHelpers.createClass(GroupTree, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: _classList.default.join('groups', this.expanded ? 'expanded' : '')
      }, this.props.children, /*#__PURE__*/_react.default.createElement(GroupNode, {
        node: this.tree
      }));
    }
  }]);
  return GroupTree;
}(_react.Component), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "tree", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "expanded", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
var GroupNode = (_class3 = /*#__PURE__*/function (_Component2) {
  babelHelpers.inherits(GroupNode, _Component2);

  var _super2 = _createSuper(GroupNode);

  function GroupNode() {
    var _this2;

    babelHelpers.classCallCheck(this, GroupNode);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = _super2.call.apply(_super2, [this].concat(args));
    babelHelpers.initializerDefineProperty(_this2, "node", _descriptor3, babelHelpers.assertThisInitialized(_this2));
    return _this2;
  }

  babelHelpers.createClass(GroupNode, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "group-node",
        "data-parent-id": this.node.id,
        "data-catalog-root": this.node.isCatalogRoot
      }, this.node.isCatalogRoot ? null : /*#__PURE__*/_react.default.createElement("a", {
        className: _classList.default.join('group', this.node.isActive && 'active', this.node.isChildActive && 'child-active'),
        href: this.node.href
      }, this.node.title), this.node.children.map(function (node) {
        return /*#__PURE__*/_react.default.createElement(GroupNode, {
          node: node,
          key: node.id
        });
      }), !!this.node.separatorAfter && /*#__PURE__*/_react.default.createElement("hr", null));
    }
  }]);
  return GroupNode;
}(_react.Component), (_descriptor3 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "node", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class3);

var GroupHeader = function GroupHeader(_ref) {
  var callToAction = _ref.callToAction,
      group = _ref.group;
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h1", {
    className: "survey-header"
  }, callToAction), /*#__PURE__*/_react.default.createElement("div", {
    className: "catalog-item"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "photo"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "list-image",
    style: {
      backgroundImage: "url(".concat(group.image, ")")
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "catalog-item-info"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "catalog-item-title"
  }, group.title))));
};

exports.GroupHeader = GroupHeader;
var CatalogGroupPage = (_class5 = /*#__PURE__*/function (_Component3) {
  babelHelpers.inherits(CatalogGroupPage, _Component3);

  var _super3 = _createSuper(CatalogGroupPage);

  function CatalogGroupPage() {
    var _this3;

    babelHelpers.classCallCheck(this, CatalogGroupPage);

    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    _this3 = _super3.call.apply(_super3, [this].concat(args));
    _this3.state = Object.assign({
      filter: _this3.props.filter,
      sort: _this3.props.sortOrder,
      types: [{
        id: '',
        value: 'All'
      }].concat(_this3.props.tileList.map(function (_ref2) {
        var id = _ref2.type,
            value = _ref2.typeLabel;
        return {
          id: id,
          value: value
        };
      }).reduce(function (prev, next) {
        return prev.filter(function (v) {
          return v.id == next.id;
        }).length ? prev : prev.concat(next);
      }, []).sort(function (left, right) {
        return left.value.toLowerCase() < right.value.toLowerCase() ? -1 : 1;
      })),
      sorts: _this3.props.asProductGroup || _this3.props.asProductGroup ? [{
        id: 'orderCount',
        value: 'Most Popular'
      }, {
        id: 'priceAsc',
        value: 'Price Low to High'
      }, {
        id: 'priceDesc',
        value: 'Price High to Low'
      }, {
        id: 'alpha',
        value: 'A-Z'
      }, {
        id: 'reverseAlpha',
        value: 'Z-A'
      }] : [{
        id: 'default',
        value: 'None'
      }, {
        id: 'alpha',
        value: 'A-Z'
      }, {
        id: 'reverseAlpha',
        value: 'Z-A'
      }, {
        id: 'newest',
        value: 'Newest'
      }, {
        id: 'oldest',
        value: 'Oldest'
      }, {
        id: 'views',
        value: 'Most Viewed'
      }].slice(_this3.props.includeUserSpecifiedSort ? 0 : 1),
      mobileMenuExpanded: false,
      useMobile: false
    }, _this3._fromHistory());
    _this3.filterMethods = {};
    _this3.sortMethods = {};
    return _this3;
  }

  babelHelpers.createClass(CatalogGroupPage, [{
    key: "_fromHistory",
    value: function _fromHistory() {
      var x = {};

      if (window.history && window.history.state && !this.props.isSearchPage) {
        if ('filter' in window.history.state) x.filter = window.history.state.filter;
        if ('sort' in window.history.state) x.sort = window.history.state.sort;
      }

      return x;
    }
  }, {
    key: "_updateHistory",
    value: function _updateHistory() {
      if (window.history && !this.props.isSearchPage) {
        window.history.replaceState({
          filter: this.state.filter,
          sort: this.state.sort
        }, "", location.href);
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this4 = this;

      if (this.state.types.filter(function (v) {
        return Array.isArray(_this4.state.filter) ? _this4.state.filter.includes(v.id) : v.id == _this4.state.filter;
      }).length == 0 && !this.props.isSearchPage) {
        this.doFilter("");
      }

      if (this.state.sorts.filter(function (v) {
        return v.id == _this4.state.sort;
      }).length == 0) {
        this.doSort(this.state.sorts[0].id);
      }

      $(document).on('sitePropsUpdated', this.sitePropsUpdated);

      try {
        this.mediaQuery = window.matchMedia('(max-width: 767px)');

        if (this.mediaQuery.matches) {
          this.setState({
            useMobile: true
          });
        }

        this.mediaQuery.addListener(this.mediaQueryChanged);
      } catch (e) {}
    }
  }, {
    key: "mediaQueryChanged",
    value: function mediaQueryChanged() {
      if (this.state.useMobile != this.mediaQuery.matches) {
        this.setState({
          useMobile: this.mediaQuery.matches
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      $(document).off('sitePropsUpdated', this.sitePropsUpdated);

      try {
        this.mediaQuery.removeListener(this.mediaQueryChanged);
      } catch (e) {}
    }
  }, {
    key: "sitePropsUpdated",
    value: function sitePropsUpdated() {
      if (_reactDom.default.findDOMNode(this)) {
        if (!document.documentElement.contains(_reactDom.default.findDOMNode(this))) {
          _reactDom.default.unmountComponentAtNode(_reactDom.default.findDOMNode(this));
        }
      }
    }
  }, {
    key: "getFilter",
    value: function getFilter(name) {
      if (this.filterMethods[name]) return this.filterMethods[name];
      return this.filterMethods[name] = this.doFilter.bind(this, name);
    }
  }, {
    key: "doFilter",
    value: function doFilter(value, event) {
      this.setState({
        filter: value
      }, this._updateHistory);

      if (this.props.setFilter) {
        this.props.setFilter(value);
      }

      if (event) event.preventDefault();
      return false;
    }
  }, {
    key: "getSort",
    value: function getSort(name) {
      if (!this.sortMethods[name]) this.sortMethods[name] = this.doSort.bind(this, name);
      return this.sortMethods[name];
    }
  }, {
    key: "doSort",
    value: function doSort(value, event) {
      this.setState({
        sort: value
      }, this._updateHistory);

      if (this.props.setSort) {
        this.props.setSort(value);
      }

      if (event) event.preventDefault();
      return false;
    }
  }, {
    key: "getRecords",
    value: function getRecords() {
      var _this$state$filter,
          _this5 = this;

      var items = this.props.tileList.slice();
      if ((_this$state$filter = this.state.filter) !== null && _this$state$filter !== void 0 && _this$state$filter.length) items = items.filter(function (item) {
        return Array.isArray(_this5.state.filter) ? _this5.state.filter.includes(item.type) : item.type == _this5.state.filter;
      });
      var sortType;
      sortType = this.state.sort;

      if (sortType != 'default') {
        var reverse = false;

        var sort = function sort(a, b) {
          return 0;
        };

        switch (sortType) {
          case 'orderCount':
            sort = function sort(a, b) {
              if (a.orderingInfo && b.orderingInfo) {
                if (a.orderingInfo.orderCount == b.orderingInfo.orderCount) return a.orderingInfo.index - b.orderingInfo.index;
                return b.orderingInfo.orderCount - a.orderingInfo.orderCount;
              }

              return 0;
            };

            break;

          case 'priceDesc':
            reverse = true;

          case 'priceAsc':
            sort = function sort(a, b) {
              if (a.orderingInfo && b.orderingInfo) {
                return a.orderingInfo.itemPrice - b.orderingInfo.itemPrice;
              }

              return 0;
            };

            break;

          case 'reverseAlpha':
            reverse = true;

          case 'alpha':
            sort = function sort(left, right) {
              return left.title.toLowerCase() < right.title.toLowerCase() ? -1 : 1;
            };

            break;

          case 'oldest':
            reverse = true;

          case 'newest':
            sort = function sort(left, right) {
              return left.date - right.date;
            };

            break;

          case 'views':
            reverse = true;

            sort = function sort(left, right) {
              return (left.views || 0) - (right.views || 0);
            };

            break;
        }

        items.sort(sort);
        if (reverse) items = items.reverse();
      }

      return items;
    }
  }, {
    key: "link",
    value: function link(opts) {
      if (this.props.base == '') return 'javascript:void(0)';
      var arg = {
        q: this.props.query,
        sort: this.props.defaultSortOrder,
        filter: this.props.defaultFilterType
      };
      Object.assign(arg, opts);
      if (arg.q == '') delete arg.q;
      if (arg.sort == this.props.defaultSortOrder) delete arg.sort;
      if (arg.filter == this.props.defaultFilterType) delete arg.filter;
      var qs = Object.keys(arg).map(function (v) {
        return [v, arg[v]].map(encodeURIComponent).join('=');
      }).join('&');
      return this.props.base + (qs ? "?".concat(qs) : '');
    }
  }, {
    key: "toggleMenu",
    value: function toggleMenu() {
      this.setState(function (st) {
        return {
          mobileMenuExpanded: !st.mobileMenuExpanded
        };
      });
    }
  }, {
    key: "showCatalogNav",
    value: function showCatalogNav() {
      var M = new _catalogMobileNav.default( /*#__PURE__*/_react.default.createElement(GroupTree, {
        tree: this.props.groupTree,
        expanded: true
      }));
      M.show();
    }
  }, {
    key: "submitTopic",
    value: function submitTopic() {
      var M = new _TopicModal.default(this.props.groupId, /*#__PURE__*/_react.default.createElement(GroupHeader, {
        callToAction: this.props.topicButtonText || 'Submit a Topic',
        group: this.props.groupInfo
      }));
      M.show();
    }
  }, {
    key: "render",
    value: function render() {
      var _this6 = this;

      var asProductGroup = true;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: _classList.default.join(this.props.className, this.props.itemStyle == 'banners' ? 'stack-container' : '')
      }, !this.props.isSearchPage && asProductGroup && /*#__PURE__*/_react.default.createElement("div", {
        className: "search"
      }, /*#__PURE__*/_react.default.createElement("form", {
        onSubmit: function onSubmit() {
          return false;
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "mobile-menu-icon",
        onClick: this.showCatalogNav
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icons",
        "data-icon": "more_vert"
      }), /*#__PURE__*/_react.default.createElement("p", null, "Categories")), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
        className: "sort-header"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "input-group-btn search-button"
      }, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn dropdown-toggle",
        type: "button",
        onClick: function onClick() {
          return _this6.props.asProductGroup ? _search.default.showProducts() : _search.default.showDocuments();
        }
      }, /*#__PURE__*/_react.default.createElement("span", null, "Search ", /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icons",
        "data-icon": "search"
      })))), /*#__PURE__*/_react.default.createElement("div", {
        className: "input-group-btn dropdown sort-button"
      }, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn dropdown-toggle",
        "data-toggle": "dropdown"
      }, /*#__PURE__*/_react.default.createElement("span", null, "Sort ", /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icons",
        "data-icon": "filter_list"
      }))), /*#__PURE__*/_react.default.createElement("ul", {
        className: "dropdown-menu dropdown-menu-right"
      }, this.state.sorts.map(function (type) {
        return /*#__PURE__*/_react.default.createElement("li", {
          key: type.id,
          className: type.id == _this6.state.sort ? 'active' : ''
        }, /*#__PURE__*/_react.default.createElement("a", {
          href: _this6.link({
            sort: type.id
          }),
          onClick: _this6.getSort(type.id)
        }, type.value));
      }))))))), this.props.itemStyle == 'topicList' && /*#__PURE__*/_react.default.createElement("div", {
        className: "topic-header"
      }, /*#__PURE__*/_react.default.createElement("h1", null, this.props.topicHeaderText || "Select a topic to join the conversation."), /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        className: "btn btn-primary",
        onClick: this.submitTopic
      }, this.props.topicButtonText || "Submit a Topic")), /*#__PURE__*/_react.default.createElement("div", {
        className: _classList.default.join('content', this.props.groupTree && this.props.itemStyle != 'banners' && 'has-groups', this.props.asProductGroup && this.props.cartItems ? 'has-cart' : '')
      }, !this.props.isSearchPage && this.props.groupTree && this.props.itemStyle != 'banners' && /*#__PURE__*/_react.default.createElement(GroupTree, {
        expanded: this.state.mobileMenuExpanded,
        tree: this.props.groupTree
      }, asProductGroup && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
        className: "sort-header",
        style: {
          visibility: 'hidden'
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "input-group-btn search-button"
      }, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn dropdown-toggle",
        type: "button",
        onClick: function onClick() {
          return _this6.props.asProductGroup ? _search.default.showProducts() : _search.default.showDocuments();
        }
      }, /*#__PURE__*/_react.default.createElement("span", null, "Search ", /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icons",
        "data-icon": "search"
      })))), /*#__PURE__*/_react.default.createElement("div", {
        className: "input-group-btn dropdown sort-button"
      }, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn dropdown-toggle",
        "data-toggle": "dropdown"
      }, /*#__PURE__*/_react.default.createElement("span", null, "Sort ", /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icons",
        "data-icon": "filter_list"
      }))), /*#__PURE__*/_react.default.createElement("ul", {
        className: "dropdown-menu dropdown-menu-right"
      }, this.state.sorts.map(function (type) {
        return /*#__PURE__*/_react.default.createElement("li", {
          key: type.id,
          className: type.id == _this6.state.sort ? 'active' : ''
        }, /*#__PURE__*/_react.default.createElement("a", {
          href: _this6.link({
            sort: type.id
          }),
          onClick: _this6.getSort(type.id)
        }, type.value));
      })))))), /*#__PURE__*/_react.default.createElement("div", {
        className: _classList.default.join('records', this.state.mobileMenuExpanded ? 'expanded' : ''),
        ref: this.gotRecordBlock
      }, asProductGroup && !this.props.isSearchPage && /*#__PURE__*/_react.default.createElement("div", {
        className: "card-container card-".concat(this.props.itemStyle == 'cards' ? this.props.asProductGroup ? this.state.useMobile || !this.props.asProductGrid ? 'list' : 'grid' : 'grid' : 'tile')
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "sort-header"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "input-group-btn search-button"
      }, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn dropdown-toggle",
        type: "button",
        onClick: function onClick() {
          return _this6.props.asProductGroup ? _search.default.showProducts() : _search.default.showDocuments();
        }
      }, /*#__PURE__*/_react.default.createElement("span", null, "Search ", /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icons",
        "data-icon": "search"
      })))), /*#__PURE__*/_react.default.createElement("div", {
        className: "input-group-btn dropdown sort-button"
      }, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn dropdown-toggle",
        "data-toggle": "dropdown"
      }, /*#__PURE__*/_react.default.createElement("span", null, "Sort ", /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icons",
        "data-icon": "filter_list"
      }))), /*#__PURE__*/_react.default.createElement("ul", {
        className: "dropdown-menu dropdown-menu-right"
      }, this.state.sorts.map(function (type) {
        return /*#__PURE__*/_react.default.createElement("li", {
          key: type.id,
          className: type.id == _this6.state.sort ? 'active' : ''
        }, /*#__PURE__*/_react.default.createElement("a", {
          href: _this6.link({
            sort: type.id
          }),
          onClick: _this6.getSort(type.id)
        }, type.value));
      }))))), this.props.itemStyle == 'banners' ? this.getRecords().map(function (record) {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "item-banner",
          ref: _this6.banner,
          key: record.id
        }, /*#__PURE__*/_react.default.createElement(require(record.banner.child_type).default, record.banner));
      }) : this.props.itemStyle == 'topicList' ? /*#__PURE__*/_react.default.createElement("div", {
        className: "topic-container"
      }, this.getRecords().map(function (record) {
        return /*#__PURE__*/_react.default.createElement("div", {
          key: record.id,
          className: "topic-item",
          ref: _this6.card
        }, /*#__PURE__*/_react.default.createElement(require(record.card.child_type).default, record.card));
      })) : /*#__PURE__*/_react.default.createElement("div", {
        className: "card-container card-".concat(this.props.itemStyle == 'cards' ? this.props.asProductGroup ? this.state.useMobile || !this.props.asProductGrid ? 'list' : 'grid' : 'grid' : 'tile')
      }, this.getRecords().map(function (record) {
        return /*#__PURE__*/_react.default.createElement("div", {
          key: record.id,
          className: "card",
          ref: _this6.card
        }, /*#__PURE__*/_react.default.createElement(require(record.card.child_type).default, record.card));
      }))), this.props.cartItems && /*#__PURE__*/_react.default.createElement(_Cart.default, {
        contents: this.props.cartItems,
        hasPreviousOrders: this.props.hasPreviousOrders
      }, asProductGroup && !this.props.isSearchPage && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
        className: "sort-header",
        style: {
          visibility: 'hidden'
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "input-group-btn search-button"
      }, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn dropdown-toggle",
        type: "button",
        onClick: function onClick() {
          return _this6.props.asProductGroup ? _search.default.showProducts() : _search.default.showDocuments();
        }
      }, /*#__PURE__*/_react.default.createElement("span", null, "Search ", /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icons",
        "data-icon": "search"
      })))), /*#__PURE__*/_react.default.createElement("div", {
        className: "input-group-btn dropdown sort-button"
      }, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn dropdown-toggle",
        "data-toggle": "dropdown"
      }, /*#__PURE__*/_react.default.createElement("span", null, "Sort ", /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icons",
        "data-icon": "filter_list"
      }))), /*#__PURE__*/_react.default.createElement("ul", {
        className: "dropdown-menu dropdown-menu-right"
      }, this.state.sorts.map(function (type) {
        return /*#__PURE__*/_react.default.createElement("li", {
          key: type.id,
          className: type.id == _this6.state.sort ? 'active' : ''
        }, /*#__PURE__*/_react.default.createElement("a", {
          href: _this6.link({
            sort: type.id
          }),
          onClick: _this6.getSort(type.id)
        }, type.value));
      }))))))));
    }
  }, {
    key: "card",
    value: function card(element) {
      var tgt = element ? element.querySelector('.pie') : null;
      if (tgt) Pie.pie(tgt);
    }
  }, {
    key: "gotRecordBlock",
    value: function gotRecordBlock(element) {
      if (element != this._recordBlock) {
        if (this._recordBlock) {
          $(this._recordBlock).off('click.document');
        }

        this._recordBlock = element;

        if (element) {
          $(element).on('click.document', '[data-show-document][data-access=enabled]', function (event) {
            var _this7 = this;

            event.preventDefault();
            var D = JSON.parse(this.dataset.pdfOptions);
            var tgt;
            var cancel = false;
            var f;

            if (!D || !D.pdf) {
              tgt = window.open('about:blank', '_blank');
            } else {
              f = document.createElement('div');
              f.id = 'document-viewer-modal-wrap';
              f.className = 'modal-wrapper fade';
              f.innerHTML = "\n\t\t\t\t\t\t\t<div class=\"modal modal-full modal-full-align-top fade\" id=\"document-viewer-modal\" role=\"dialog\" tabindex=\"-1\" aria-hidden=\"true\" data-backdrop-parent=\"#document-viewer-modal-wrap\">\n\t\t\t\t\t\t\t\t<div class=\"modal-dialog\">\n\t\t\t\t\t\t\t\t\t<div class=\"modal-content\">\n\t\t\t\t\t\t\t\t\t\t<div class=\"modal-header\">\n\t\t\t\t\t\t\t\t\t\t\t".concat(BLX.modalCloseButton(), "\n\t\t\t\t\t\t\t\t\t\t\t<h4 class=\"modal-title\">\n\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"material-icons\" data-icon=\"insert_drive_file\"></span>\n\t\t\t\t\t\t\t\t\t\t\t\tDocument\n\t\t\t\t\t\t\t\t\t\t\t</h4>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class=\"modal-body\">\n\t\t\t\t\t\t\t\t\t\t\t<div data-spin=\"true\" class=\"spinning\" style=\"position: absolute; top: calc(50% - 37.5px); top: calc(50% + (var(--scalable-unit, 16px) * -37.5 / 16)); left: calc(50% - 37.5px); left: calc(50% + (var(--scalable-unit, 16px) * -37.5 / 16)); width: 75px; width: calc(var(--scalable-unit) * 75 / 16); height: 75px; height: calc(var(--scalable-unit) * 75 / 16);\"></div>\n\t\t\t\t\t\t\t\t\t\t\t<iframe style=\"opacity: 0;\" id=\"document-viewer\"></iframe>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t");
              document.body.appendChild(f);
              $(f.querySelector('.modal')).on('hidden.bs.modal', function () {
                cancel = true;
                $(f).remove();
              }).modal('show');
            }

            (0, _fetch.default)("access/".concat(this.dataset.tool, "/").concat(this.dataset.showDocument)).then(function (result) {
              return result.json();
            }).then(function (data) {
              if (cancel) return;

              if (data.access == 'enabled') {
                require('trackObjectView').default('catalog', _this7.dataset.showDocument, true);

                if (tgt) {
                  tgt.location.href = data.detail.signedDocumentURL;
                } else {
                  var opt = {};
                  opt.toolbar = !!D.toolbar;
                  opt.file = data.detail.signedDocumentURL;
                  opt.controls = Object.keys(D.toolbar).filter(function (v) {
                    return D.toolbar[v];
                  }).join(",");
                  if (data.detail.password) opt.password = data.detail.password;
                  var optString = Object.keys(opt).map(function (key) {
                    return [key, opt[key]].map(encodeURIComponent).join('=');
                  }).join('&');
                  f.querySelector('iframe').src = '/admin/platform/plugins/' + _this7.dataset.corePlugin + '/libraries/pdf.js/web/viewer.html?' + optString;
                  f.querySelector('iframe').style.opacity = 1;
                  var x = f.querySelector('div[data-spin]');
                  x.parentNode.removeChild(x);
                }
              } else {
                if (tgt) tgt.close();

                if (f) {
                  $(f.querySelector('.modal')).modal('hide');
                }

                (0, _noty.showNotificationText)("You do not have permission to view that resource.", "danger", "warning");
              }
            });
          });
        }
      }
    }
  }]);
  return CatalogGroupPage;
}(_react.Component), (babelHelpers.applyDecoratedDescriptor(_class5.prototype, "_updateHistory", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "_updateHistory"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "mediaQueryChanged", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "mediaQueryChanged"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "sitePropsUpdated", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "sitePropsUpdated"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "toggleMenu", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "toggleMenu"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "showCatalogNav", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "showCatalogNav"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "submitTopic", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "submitTopic"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "card", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "card"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "gotRecordBlock", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "gotRecordBlock"), _class5.prototype)), _class5);
exports.CatalogGroupPage = CatalogGroupPage;